import { createContext, PropsWithChildren, useContext, useMemo } from 'react'

import { SchemaBuilderContextProps } from './types'

const SchemaBuilderContext = createContext<SchemaBuilderContextProps>({})

export const useSchemaBuilderContext = () => useContext(SchemaBuilderContext)

export function SchemaBuilderContextProvider({
  variablesSchema,
  referenceCollections,
  referenceSchemas,
  readOnly,
  isObject,
  children,
}: PropsWithChildren<SchemaBuilderContextProps>) {
  const value = useMemo(
    () => ({
      variablesSchema,
      referenceCollections,
      referenceSchemas,
      readOnly,
      isObject,
    }),
    [
      variablesSchema,
      JSON.stringify(referenceCollections),
      JSON.stringify(referenceSchemas),
      isObject,
      readOnly,
    ],
  )

  return (
    <SchemaBuilderContext.Provider value={value}>
      {children}
    </SchemaBuilderContext.Provider>
  )
}
